import { TextField } from "@mui/material"
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { observer } from "mobx-react-lite"
import { useStore } from "../../../app/stores/store"

const HomeTrendEndDate = () => {
    const { setSelectedEndDate, selectedEndDate, selectedStartDate } = useStore().homeTrendChartStore
    
    const handleChange = (e: any) => {
        setSelectedEndDate(e)
    }
    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                views={['year', 'month']}
                inputFormat={'MMMM yyyy'}
                disableMaskedInput
                renderInput={(params) => <TextField fullWidth {...params}></TextField>} 
                value={selectedEndDate}
                onChange={handleChange}
                minDate={new Date(selectedStartDate)}
                maxDate={new Date()}
            />
        </LocalizationProvider>
    )
}

export default observer(HomeTrendEndDate)